import { useDispatch } from 'react-redux';
import { useMutation } from '@tanstack/react-query';

import { setAppLoader } from '@/redux/common/CommonActions';

import type {
  CheckDuplicateOCClaimRequestParams,
  CheckDuplicateOCClaimResponse,
} from '../data-provider/check-duplicate-claim';
import { checkDuplicateOCClaim } from '../data-provider/check-duplicate-claim';

export interface UseCheckDuplicateOCClaimOptions {
  onError?: (error: Error) => void;
  onSuccess?: (status: CheckDuplicateOCClaimResponse) => void;
  showLoader?: boolean;
}

export const useCheckDuplicateOCClaim = ({
  onError,
  onSuccess,
  showLoader = true,
}: UseCheckDuplicateOCClaimOptions = {}) => {
  const dispatch = useDispatch();

  return useMutation({
    mutationFn: (params: CheckDuplicateOCClaimRequestParams) => checkDuplicateOCClaim(params),
    onError: (error: Error) => {
      if (showLoader) {
        dispatch(setAppLoader(false));
      }
      onError?.(error);
    },
    onMutate: () => {
      if (showLoader) {
        dispatch(setAppLoader(true));
      }
    },
    onSuccess: (status) => {
      if (showLoader) {
        dispatch(setAppLoader(false));
      }
      onSuccess?.(status);
    },
  });
};
